import React from 'react';
import PropTypes from 'prop-types';
import { strings } from 'APP_ROOT/localization';

const PLACEHOLDER_IMAGE = '/images/ic_person_48px.svg';

export default class ProfileImage extends React.Component {

    render() {
        const {
            imageUrl,
            caption,
            imgSize,
            loading,
        } = this.props;

        const img = (
            <img
                alt='profile'
                src={imageUrl ? imageUrl : PLACEHOLDER_IMAGE}
                className={imageUrl ? '' : 'placeholder'}
            />
        );

        return (
            <div>
                <div className='profile-image' style={imgSize && { width: imgSize }}> 
                    <div
                        className='profile-image-frame'
                        style={ imgSize && {
                            width: imgSize,
                            height: imgSize
                        }}
                    >
                        { !loading && img }
                        { loading && 
                                <div className='profile-image-overlay'>
                                    <div className='loading-spinner spinner-border' role='status'>
                                        <span className="sr-only">{strings.loading}</span>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
                <div className='profile-image-caption'>
                    { this.props.expander ?
                            <div className={this.props.expanderClass}>•</div> : null
                    }
                    {caption}
                </div>
            </div>
        );
    }
}

ProfileImage.defaults = {
    expander: false,
    expanderClass: ''
}

ProfileImage.propTypes = {
    caption: PropTypes.string,
    loading: PropTypes.bool,
    imageUrl: PropTypes.string,
    expander: PropTypes.bool,
    expanderClass: PropTypes.string,
}
